import { render, staticRenderFns } from "./com-app-menu.vue?vue&type=template&id=6948248a&"
import script from "./com-app-menu.vue?vue&type=script&lang=js&"
export * from "./com-app-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports